import React, { createContext, useContext, useReducer, useEffect } from 'react';

const BetContext = createContext();

const initialState = {
  mybetslip: [],
};

const actionTypes = {
  ADD_BET: 'ADD_BET',
  REMOVE_BET: 'REMOVE_BET',
  UPDATE_STAKE: 'UPDATE_STAKE',
  CLEAR_SLIP: 'CLEAR_SLIP',
  LOAD_FROM_STORAGE: 'LOAD_FROM_STORAGE',
};

const betReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.ADD_BET:
      if (state.mybetslip.some(bet => bet.id === action.payload.id)) {
        return state;
      }
      return {
        ...state,
        mybetslip: [...state.mybetslip, {
          ...action.payload,
          stake: 0,
          payout: 0
        }]
      };
      
    case actionTypes.REMOVE_BET:
      return {
        ...state,
        mybetslip: state.mybetslip.filter(bet => bet.id !== action.payload)
      };
      
    case actionTypes.UPDATE_STAKE:
      return {
        ...state,
        mybetslip: state.mybetslip.map(bet => 
          bet.id === action.payload.id
            ? {
                ...bet,
                stake: action.payload.stake,
                payout: action.payload.stake * bet.odds
              }
            : bet
        )
      };
      
    case actionTypes.CLEAR_SLIP:
      return {
        ...state,
        mybetslip: []
      };
      
    case actionTypes.LOAD_FROM_STORAGE:
      return {
        ...state,
        mybetslip: action.payload || []
      };
      
    default:
      return state;
  }
};

export const BetProvider = ({ children }) => {
  const [state, dispatch] = useReducer(betReducer, initialState);
  
  useEffect(() => {
    const savedBets = localStorage.getItem('mybetslip');
    if (savedBets) {
      try {
        dispatch({
          type: actionTypes.LOAD_FROM_STORAGE,
          payload: JSON.parse(savedBets)
        });
      } catch (error) {
        console.error('Failed to parse saved bets:', error);
      }
    }
  }, []);
  
  useEffect(() => {
    localStorage.setItem('mybetslip', JSON.stringify(state.mybetslip));
  }, [state.mybetslip]);

  const actions = {
    addBetToSlip: (bet) => {
      dispatch({
        type: actionTypes.ADD_BET,
        payload: bet
      });
    },
    
    removeBetFromSlip: (id) => {
      dispatch({
        type: actionTypes.REMOVE_BET,
        payload: id
      });
    },
    
    updateStakeInSlip: (id, stake) => {
      dispatch({
        type: actionTypes.UPDATE_STAKE,
        payload: { id, stake }
      });
    },
    
    clearBetSlip: () => {
      dispatch({ type: actionTypes.CLEAR_SLIP });
    }
  };

  const value = {
    mybetslip: state.mybetslip,
    ...actions
  };

  return (
    <BetContext.Provider value={value}>
      {children}
    </BetContext.Provider>
  );
};

export const useBet = () => {
  const context = useContext(BetContext);
  if (!context) {
    throw new Error('useBet must be used within a BetProvider');
  }
  return context;
};